import { Component, OnInit } from '@angular/core';
import { CommonUtilities } from 'src/assets/js/common-utilities';

@Component({
  selector: 'app-c-servicelocation',
  templateUrl: './c-servicelocation.component.html',
  styleUrls: ['./c-servicelocation.component.css']
})
export class CServicelocationComponent implements OnInit {
  CustomersListGrid:any[];
  SpecialDeliveryList:any[]
  selectedtab: number = 0;
  displayBasic: boolean;
  _ServiceLocation:any[]
  _Tier:any[]
  _Requirments:any[]
  _SpecialDelivery:any[]
  _FloorType:any[];
  _State:any[]
  _District:any[]
  _TatBased:any[]
  constructor(private utility:CommonUtilities) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    this._ServiceLocation  = [
      {locationid:'1',locationname:'Tamil Nadu'},
      {locationid:'2',locationname:'Puducherry'},
      {locationid:'3',locationname:'Karnataka'},
    ]
    this._Tier  = [
      {tierid:'1',tiername:'Tier1'},
      {tierid:'2',tiername:'Tier2'},
      
    ]
    this._Requirments  = [
      {podid:'1',podname:'Bill only without POD'},
      {podid:'1',podname:'Bill with online POD or Soft Copy'},
      {podid:'1',podname:'Bill with hard Copy POD'},
      {podid:'1',podname:'POD Submission after the month of POD'},
    ]
    this._SpecialDelivery  = [
      {deliveryid:'1',deliveryname:'First Floor'},
      {deliveryid:'2',deliveryname:'Second Floor'},
      {deliveryid:'3',deliveryname:'Modern Retail Delivery'},
      {deliveryid:'4',deliveryname:'Appoinment Delivery'},
      {deliveryid:'5',deliveryname:'Police Canteen'},
      {deliveryid:'6',deliveryname:'Military Canteen'},
    ]
    this._FloorType = [
      {floorid:'1',floorname:'Ground Floor'},
      {floorid:'2',floorname:'1st Floor'},
      {floorid:'3',floorname:'2nd Floor'},
      {floorid:'4',floorname:'3rd Floor'},
     
    ];
    this._State = [
      {stateid:'1',statename:'TAMIL NADU'},
      {stateid:'2',statename:'Kerala'},
      {stateid:'3',statename:'Mumbai'},
      {stateid:'4',statename:'Delhi'},
    ];
    this._District = [
      {districtid:'1',districtname:'Trichy'},
      {districtid:'2',districtname:'Chennai'},
      {districtid:'3',districtname:'Karur'},
      {districtid:'4',districtname:'Erode'},
     
    ]
    this._TatBased = [
      {tatid:'1',tatname:'Customer'},
      {tatid:'2',tatname:'Internal'},
      
     
    ]
  }
  showBasicDialog(){
    this.displayBasic = true;
  }
  goBack(event){

  }

}
